function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = "px/K";


//////////////////
// WEBPACK FOOTER
// ./src/assets nonrecursive ^\.\/logo.(png|jpe?g|svg)$
// module id = px/K
// module chunks = 1